export default __webpack_public_path__ + "static/media/pic45.60929bd6.jpg";